export default function StrokeLeft() {
    return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={30} height={30} fill="none">
            <path
                fill="#F6D139"
                fillRule="evenodd"
                d="M8.707.293a1 1 0 0 1 0 1.414L3.414 7H19a1 1 0 1 1 0 2H3.414l5.293 5.293a1 1 0 1 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z"
                clipRule="evenodd"
            />
        </svg>)
}